const productList = document.querySelector('.product-list');

if (productList) {
  const productThumbHover = () => {
    const allVariantItems = document.querySelectorAll('.product-card__variants-item');
    let timeout;

    allVariantItems.forEach((item) => {
      const parent = item.closest('.product-card');
      const defaultImage = parent.querySelector('.product-card__image img');
      const defaultImageSrc = defaultImage.getAttribute('src');
      const defaultImageDataSrc = defaultImage.getAttribute('data-src');
      const defaultSrc = defaultImageDataSrc || defaultImageSrc;

      item.addEventListener('mouseenter', (el) => {
        clearTimeout(timeout);
        const thumbImage = el.target.querySelector('img');
        const thumbImageSrc = thumbImage.getAttribute('src');
        const thumbImageDataSrc = thumbImage.getAttribute('src');
        const thumbSrc = thumbImageDataSrc || thumbImageSrc;
        defaultImage.setAttribute('src', thumbSrc);
      });

      item.addEventListener('mouseleave', () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          defaultImage.setAttribute('src', defaultSrc);
        }, 100);
      });
    });
  };

  // Get Category slugss
  const getCategorySlugs = () => {
    const categorySlugs = [];
    productList.querySelectorAll('.product-categories__item.is-open').forEach((categoryItem) => {
      const subItems = categoryItem.querySelectorAll('.product-categories__sub-item.is-active');

      if (subItems.length) {
        subItems.forEach((subItem) => {
          categorySlugs.push(subItem.dataset.slug);
        });
      } else {
        categorySlugs.push(categoryItem.querySelector('.product-categories__button').dataset.slug);
      }
    });

    return categorySlugs;
  };

  // Get Color IDs
  const getColorIds = () => {
    const colorIds = [];
    productList.querySelectorAll('input[name="product-color"]:checked').forEach((color) => {
      colorIds.push(color.id);
    });

    return colorIds;
  };

  // Get order by value
  const getOrderBy = () => {
    const orderBy = productList.querySelector('input[name="sort_product"]:checked');
    return orderBy ? orderBy.id.replace('sort_', '') : 'date';
  };

  // Axios get product list
  const axiosGetProductListHtml = async (page = 1) => {
    const formDataInput = {
      action: 'getProductListHtml',
      categorySlugs: getCategorySlugs(),
      colorIds: getColorIds(),
      orderBy: getOrderBy(),
      parentColorId: productList.querySelector('.color-selection').dataset.parentId || 0,
      page,
    };

    try {
      const response = await axios.post(localData.siteURL, formDataInput);
      productList.querySelector('.product-list__list').innerHTML = response.data.data.html_list;
      productList.querySelector('.product-list__footer').innerHTML = response.data.data.html_footer;
      productList.querySelector('.product-list__result p').innerHTML = response.data.data.html_result_text;
      productList.querySelector('.color-selection__inner').innerHTML = response.data.data.html_color_filter;

      const baseUrl = window.location.href.split('?')[0];
      const urlParams = ['categorySlugs', 'colorIds', 'orderBy', 'page']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));

      productThumbHover();
    } catch (err) {
      console.error(err);
    }
  };

  // click event to filter items on product list
  const filterItems = productList.querySelectorAll('span.product-categories__button-icon');
  filterItems.forEach((item) => {
    item.addEventListener('click', (e) => {
      slideToggleProductCategories(e.target);
    });
  });

  // click event -  color filter or order items on product list
  attachEvent('.dropdown__list-item input, .color-selection__item input', 'click', () => {
    axiosGetProductListHtml();
  });

  // click event - pagination on product list and show more button
  attachEvent('a.page-numbers:not(.is-active), a.product-list__show-more-link', 'click', (e) => {
    e.preventDefault();
    productList.scrollIntoView({ block: 'start', offset: 50 });
    axiosGetProductListHtml(e.target.dataset.page ?? e.target.closest('.page-numbers').dataset.page);
  });

  // click event - open sort modal
  const sortDropdown = document.querySelector('.product-list__sort');
  const sortInputs = document.querySelectorAll('.product-list__sort input');

  const toggleSortDropdown = (toggle) => {
    sortDropdown.classList.toggle('is-open-sort', toggle);
    toggleBodyScrollLock(toggle);
  };

  attachEvent('.product-list__sort-trigger', 'click', (e) => {
    toggleSortDropdown(true);
    e.preventDefault();
  });

  attachEvent('[data-close-sort]', 'click', (e) => {
    toggleSortDropdown(false);
    e.preventDefault();
  });

  sortInputs.forEach((input) => {
    input.addEventListener('change', () => {
      toggleSortDropdown(false);
    });
  });

  productThumbHover();
}
